exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".progressBar__1j3 {\n  display: flex;\n  width: 200px;\n  height: 10px;\n  padding: 2px;\n  color: #fff;\n  border-radius: 10px;\n  border: 1px solid #0092ff; }\n  .progressBar__1j3 > div {\n    height: 100%;\n    border-radius: 10px;\n    background-color: #0092ff;\n    transition: all .2 ease; }\n", ""]);
// Exports
exports.locals = {
	"progressBar": "progressBar__1j3"
};